export enum ApiType {
  PAYMENT_GATE = "PAYMENT_GATE",
  BANK_ACCOUNT = "BANK_ACCOUNT"
}
